import * as React from "react"
import styled from 'styled-components';
import { Container } from "react-bootstrap";
import Card from 'react-bootstrap/Card';
import JsonLd from "../../components/helper"

const StyledContainer = styled(Container)`
  .card {
    width: 28rem;
    text-align: center;
    border: 0px !important;
    margin-bottom: 15px;
    margin: 10px;
    border-radius: 10px;
    padding: 10px;
  }

  .card img {
    width: 120px;
    height: 120px;
  }

  .card-title {
    font-weight: bold;
  }

  .accurate {
    background-color: #c493ff24;
  }

  .afforable {
    background-color: #f57c001c;
  }

  .accelerated {
    background-color: #93beff24;
  }

  .lists {
    padding-bottom: 30px;
  }

  .container-width {
    max-width: 90%;
    color: #4a4560 !important;
  }

  h2{
    color: #3d3a3a !important;
  }
  
  @media (max-width: 991px) {
    .lists {
      flex-wrap: wrap !important;
    }
  }
`

const DataSecurity = () => {

  let schema_data = {
    "@context": "http://schema.org",
    "@type": "Organization",
    "name": "Clearout",
    "alternateName": "Clearout.io",
    "description": "Clearout is a powerful platform that offers email verification, email finder and prospecting services to help businesses find potential customers.",
    "image": "https://clearout.io/wp-content/plugins/hybrid-composer/public/homepage-2.webp",
    "logo": "https://clearout.io/wp-content/uploads/2018/01/Clearout-New-Logo-color115.png",
    "url": "https://clearout.io/",
    "sameAs": ["https://twitter.com/clearoutio", "https://in.linkedin.com/company/clearout-io", "https://www.facebook.com/clearout.io/", "https://www.youtube.com/@ClearoutIo"]
  }

  return (
    <StyledContainer className="d-flex justify-content-center text-center">
      <div className="container-width">
        <h2 className="text-center fw-bold pb-4">Data Security</h2>
        <div className="d-flex justify-content-center lists">
          <Card className="accurate">
            <Card.Body>
              <Card.Title>Data Encryption</Card.Title>
              <Card.Text>
                We take your data security seriously. That's why we use 256-bit SSL encryption to secure the entire transmission and safeguard your information.
              </Card.Text>
            </Card.Body>
          </Card>
          <Card className="afforable">
            <Card.Body>
              <Card.Title>Data Retention</Card.Title>
              <Card.Text>
                We safeguard your data and offer flexible retention options for your email list, with default retention of 30 days or customized retention periods upon request.
              </Card.Text>
            </Card.Body>
          </Card>
          <Card className="accelerated">
            <Card.Body>
              <Card.Title>Compliance</Card.Title>
              <Card.Text>
                We adhere to the highest standards of data security, including compliance with GDPR, SOC 2 Type II and ISO norms, to ensure that your customer data is always protected.
              </Card.Text>
            </Card.Body>
          </Card>
        </div>
      </div>
      <JsonLd data={schema_data} />
    </StyledContainer>
  )
}

export default DataSecurity;